import React from 'react';

import { type TUseGlobalData } from './actions';

export type CacheContextType = TUseGlobalData;
export const CacheContext = React.createContext<CacheContextType>({} as TUseGlobalData);

export const useCacheContext = () => React.useContext(CacheContext);
